import { doLogout } from 'actions/authAction'
import {
    BASE_URL,
} from './constant'
export const REKAPBOOKING = 'REKAPBOOKING'

const rekapBokingFetchAllSuccess = (bool, booking) => {
    return {
        type: REKAPBOOKING,
        load: bool,
        data: booking
    }
}

export function rekapBookingFetchAll(data) {
    return (dispatch) => {
        dispatch(rekapBokingFetchAllSuccess(true, { data: [] }))
        let token = localStorage.getItem('tolaut@token') || null
        let config = {}
        if (token) {
            config = {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }
        } else {
            throw Error("Authentication error")
        }
        fetch(BASE_URL + 'rekapitulasi_booking', config)
            .then((response) => {
                if (response.status === 401) {
                    dispatch(doLogout())
                }
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                // dispatch(rekapBokingFetchAllSuccess(false, []))
                return response
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 200) {
                    dispatch(rekapBokingFetchAllSuccess(false, data.data))
                } else {
                    dispatch(rekapBokingFetchAllSuccess(false, { data: [] }))
                    window.alert(data.message)
                }

            })
            .catch((err) => {
                dispatch(rekapBokingFetchAllSuccess(false, { data: [], err }))
            })
    }
}